module.exports = __webpack_public_path__ + "img/pethouse12.455d0b36.jpg";